import React, { useState } from "react";
import {
  Row,
  Col,
  Typography,
  Divider,
  Empty,
  Space,
  Avatar,
  Button,
  Tag,
} from "antd";
import {
  UserOutlined,
  IdcardOutlined,
  CalendarOutlined,
  HomeOutlined,
  PhoneOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import THEME from "../theme";
import { formatDate } from "../utils";
import StyledCard from "../components/StyledCard";
import InfoItem from "../components/InfoItem";
import EditCustomerContactModal from "../components/EditCustomerContactModal";

const { Title, Text } = Typography;

const CustomerInfoTab = ({ loanData, loadLoanData, userId }) => {
  const customer = loanData?.CUSTOMER;
  const addresses = customer?.ADDRESS || [];
  const dataType = loanData?.LOAN?.DATA_TYPE;
  const contno = loanData?.LOAN?.CONTNO;

  const [editModal, setEditModal] = useState({
    open: false,
    mode: "phone",
    address: null,
  });

  const openEditPhone = () =>
    setEditModal({ open: true, mode: "phone", address: null });
  const openEditAddress = (address) =>
    setEditModal({ open: true, mode: "address", address });
  const closeEditModal = () =>
    setEditModal((prev) => ({ ...prev, open: false }));
  const handleEditSuccess = () => {
    if (contno) loadLoanData?.(contno);
  };

  if (!customer) return <Empty description="ไม่มีข้อมูล" />;
  return (
    <StyledCard
      title="ผู้เช่าซื้อ"
      icon={<UserOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
      style={{ marginBottom: 16 }}
      extra={
        <Button
          icon={<EditOutlined />}
          size="small"
          onClick={openEditPhone}
          disabled={userId !== 1 && userId !== 4}
        >
          แก้ไขเบอร์โทรศัพท์
        </Button>
      }
    >
      <Row gutter={[24, 16]}>
        <Col xs={24} lg={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              padding: "20px",
              background: THEME.light,
              borderRadius: 10,
              marginBottom: 16,
            }}
          >
            <Avatar
              size={72}
              style={{ background: THEME.gradient }}
              icon={<UserOutlined />}
            />
            <div>
              <Title level={4} style={{ margin: 0 }}>
                {customer?.SNAM}
                {customer?.NAME1} {customer?.NAME2}
              </Title>
            </div>
          </div>
          <Row gutter={[16, 12]}>
            <Col span={24}>
              <Text type="secondary" style={{ fontSize: 16 }}>
                <IdcardOutlined style={{ marginRight: 6 }} />
                เลขบัตรประชาชน
              </Text>
              <br />
              <Text copyable strong>
                {customer?.CUSCOD}
              </Text>
            </Col>
            <Col span={12}>
              <InfoItem
                label="วันเกิด"
                value={formatDate(customer?.BIRTHDT)}
                icon={<CalendarOutlined />}
              />
            </Col>
            <Col span={12}>
              <Text type="secondary" style={{ fontSize: 16 }}>
                <IdcardOutlined style={{ marginRight: 6 }} />
                อาชีพ
              </Text>
              <br />
              <Text copyable strong>
                {customer?.OCCUP || "-"}
              </Text>
            </Col>
            <Col span={12}>
              <Text type="secondary" style={{ fontSize: 16 }}>
                <IdcardOutlined style={{ marginRight: 6 }} />
                ที่ทำงาน
              </Text>
              <br />
              <Text copyable strong style={{ fontSize: 16 }}>
                {customer?.OFFIC || "-"}
              </Text>
            </Col>
            <Col span={12}>
              <Text type="secondary" style={{ fontSize: 16 }}>
                <PhoneOutlined style={{ marginRight: 6 }} />
                เบอร์ส่วนตัว
              </Text>
              <br />
              <Text copyable strong style={{ fontSize: 16 }}>
                {customer?.MOBILENO || "-"}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col xs={24} lg={12}>
          <div
            style={{
              padding: 20,
              background: `${THEME.info}08`,
              borderRadius: 10,
              borderLeft: `4px solid ${THEME.info}`,
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 8,
              }}
            >
              <Button
                icon={<PlusOutlined />}
                size="small"
                disabled={userId !== 1 && userId !== 4}
                onClick={() => openEditAddress(null)}
              >
                เพิ่มที่อยู่
              </Button>
            </div>
            {addresses.map((addr, idx) => (
              <div key={addr.ADDRNO || idx}>
                {idx > 0 && <Divider style={{ margin: "8px 0" }} />}
                <Space align="center">
                  <Text strong style={{ color: THEME.info }}>
                    <HomeOutlined style={{ marginRight: 8 }} />
                    ที่อยู่{"   "}
                    {addr.ADDRNO}
                  </Text>
                  {customer?.MAIN_ADDRNO === addr.ADDRNO && (
                    <Tag color="blue">ที่อยู่หลัก</Tag>
                  )}
                  <Button
                    icon={<EditOutlined />}
                    size="small"
                    type="text"
                    // disabled={userId !== 1 && userId !== 4}
                    disabled
                    onClick={() => openEditAddress(addr)}
                  />
                </Space>
                <br />
                <Text copyable style={{ fontSize: 16 }}>
                  {`${addr.ADDR1} ${addr.ADDR2}  ตำบล. ${addr.TUMB} อำเภอ. ${addr.AUMPDES} จังหวัด. ${addr.PROVDES} รหัสไปษรณีย์. ${addr.ZIP}`.trim()}
                </Text>
                <br />
                <Space>
                  <PhoneOutlined style={{ color: THEME.primary }} />
                  <Text strong copyable>
                    {addr.TELP || "-"}
                  </Text>
                </Space>
              </div>
            ))}
            {addresses.length === 0 && <Text>-</Text>}
          </div>
        </Col>
      </Row>
      <EditCustomerContactModal
        open={editModal.open}
        onClose={closeEditModal}
        mode={editModal.mode}
        customer={customer}
        dataType={dataType}
        addresses={addresses}
        editingAddress={editModal.address}
        onSuccess={handleEditSuccess}
      />
    </StyledCard>
  );
};

export default CustomerInfoTab;
